module.exports = __webpack_public_path__ + "img/noCarsInLight.7d828fea.png";